import {
  type Configuration,
  PublicClientApplication,
} from '@azure/msal-browser'
import { useEffect, useRef, useState } from 'react'

import { getEnvironmentSettings } from '../utility/getEnvironmentSettings'
import { useFetchAppSettings } from './useFetchAppSettings'

export const useGetMsalConfig = (customerConfig?: Partial<Configuration>) => {
  const [msalConfig, setMsalConfig] = useState<
    undefined | PublicClientApplication
  >(undefined)
  const didSetup = useRef(false)
  const { data: appSettings } = useFetchAppSettings()

  useEffect(() => {
    const setupConfig = () => {
      didSetup.current = true

      const [environment] = getEnvironmentSettings(appSettings!)

      if (
        !environment ||
        !environment.REACT_APP_CLIENT_ID ||
        !environment.REACT_APP_AUTHORITY
      ) {
        throw new Error('Missing client id or authority')
      }

      const {
        REACT_APP_CLIENT_ID,
        REACT_APP_AUTHORITY,
        REACT_APP_REDIRECT_URI,
      } = environment
      const config: Configuration = {
        ...customerConfig,
        auth: {
          clientId: REACT_APP_CLIENT_ID,
          authority: REACT_APP_AUTHORITY,
          knownAuthorities: [REACT_APP_AUTHORITY],
          redirectUri: REACT_APP_REDIRECT_URI ?? window.location.origin,
          ...customerConfig?.auth,
        },
        cache: {
          cacheLocation: 'sessionStorage', // This configures where your cache will be stored
          ...customerConfig?.cache,
        },
        system: {
          loggerOptions: {
            // this is defined in the msal-browser package: ILoggerCallback
            /* oxlint-disable-next-line max-params */
            loggerCallback: (_level, _message, containsPii) => {
              if (containsPii) {
                return
              }
              // Enable this to enable Msal logging.
              // switch (level) {
              //   case LogLevel.Error:
              //     console.error(message)
              //     return
              //   case LogLevel.Info:
              //     console.info(message)
              //     return
              //   case LogLevel.Verbose:
              //     console.debug(message)
              //     return
              //   case LogLevel.Warning:
              //     console.warn(message)
              //     return
              // }
            },
          },
          ...customerConfig?.system,
        },
      }
      setMsalConfig(new PublicClientApplication(config))
    }

    if (!didSetup.current && appSettings) {
      setupConfig()
    }
  }, [appSettings, customerConfig])

  return msalConfig
}
